export default function findCategory(id, catArray) {
  const element = catArray.find((itm) => itm.id === id);
  return element?.label ?? "";
}
